/**
 * @fileoverview Zod schemas and inferred types for MCP personal access tokens.
 * @module features/mcp/schemas/mcpToken
 */

import { z } from 'zod'

/**
 * Schema describing an MCP token as returned by the list endpoint.
 * The plaintext token value is never included in this response — only metadata.
 */
export const McpTokenSchema = z.object({
  id: z.string().uuid(),
  name: z.string().nullable(),
  createdAt: z.string(),
  lastUsedAt: z.string().nullable(),
  expiresAt: z.string(),
  revokedAt: z.string().nullable(),
})
export type McpToken = z.infer<typeof McpTokenSchema>

/**
 * Schema describing a freshly issued MCP token.
 * The `plaintextToken` field is only exposed once at creation time and must
 * be surfaced to the user immediately; subsequent fetches will not return it.
 */
export const IssuedMcpTokenSchema = z.object({
  id: z.string().uuid(),
  plaintextToken: z.string(),
  name: z.string().nullable(),
  expiresAt: z.string(),
})
export type IssuedMcpToken = z.infer<typeof IssuedMcpTokenSchema>
